import * as AuthSession from 'expo-auth-session'
import Config from 'react-native-config'

export const oauthRedirectUri = AuthSession.makeRedirectUri()

export const oauthScopes = Config.OAUTH_CONFIG_SCOPES!.split(',')

export const oauthConfig: AuthSession.AuthRequestConfig = {
    clientId: Config.OAUTH_CONFIG_CLIENT_ID!,
    redirectUri: oauthRedirectUri,
    scopes: oauthScopes,
    usePKCE: true,
}

export const oauthDiscovery: AuthSession.DiscoveryDocument = {
    authorizationEndpoint: Config.OAUTH_CONFIG_AUTHORIZATION_ENDPOINT,
    tokenEndpoint: Config.OAUTH_CONFIG_TOKEN_ENDPOINT,
}
